import { Pagination, Resource } from "@/helpers/Interfaces";
import axios from "axios";

export default class TagsService
{
    /**
     * @param model FormModel
     *
     * @returns Promise<FormModel>
     */
    public static async create(model: FormModel): Promise<Resource<FormModel>>
    {
        return (await axios.post<Resource<FormModel>>(`admin/renters/tags`, model)).data;
    }

    /**
     * @param publicId string
     * @param model FormModel
     *
     * @returns Promise<FormModel>
     */
    public static async update(publicId: string, model: FormModel): Promise<Resource<FormModel>>
    {
        return (await axios.put<Resource<FormModel>>(`admin/renters/tags/${publicId}`, model)).data;
    }

    /**
     * @param publicId string
     *
     * @returns Promise<FormModel>
     */
    public static async fetch(publicId: string): Promise<Resource<FormModel>>
    {
        return (await axios.get<Resource<FormModel>>(`admin/renters/tags/${publicId}`)).data;
    }

    /**
     *
     * @returns Promise<Pagination<Resource<ListItemModel>>
     */
    public static async getList(): Promise<Pagination<Resource<ListItemModel>>>
    {
        return (await axios.get<Pagination<Resource<ListItemModel>>>(`admin/renters/tags`)).data;
    }

    /**
     * @param search string
     * @param limit number
     *
     * @returns Promise<ListItemModel[]>
     */
    public static async getAutocompleteList(search: string, limit: number = 5): Promise<ListItemModel[]>
    {
        return (await axios.get<ListItemModel[]>('admin/renters/tags/autocomplete', {
            params: {
                search: search,
                limit: limit
            }
        })).data;
    }

    /**
     * @param publicId string
     *
     * @returns Promise<ListItemModel>
     */
    public static async fetchAutocompleteModel(publicId: string): Promise<ListItemModel>
    {
        return (await axios.get<ListItemModel>(`admin/renters/tags/autocomplete/${publicId}`)).data;
    }
}

export interface FormModel {
    name: string;
}

export interface ListItemModel extends FormModel {
    publicId: string;
    isDefault: boolean;
}

export interface TagItemModel extends ListItemModel {}
